import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { AddOrUpdateCustomDomainSettingRequest } from '../types/CustomDomainTypes';
import { ICustomDomainSettingResult } from './GetCustomDomainSettingTagRequest';


export class AddCustomDomainTagRequest extends TagRequest<AddOrUpdateCustomDomainSettingRequest,  ICustomDomainSettingResult> {
    constructor(params: AddOrUpdateCustomDomainSettingRequest) {
      super('custom_domains_service', 'createSiteCustomDomainSettings', params);
    }
}

export class UpdateCustomDomainTagRequest extends TagRequest<AddOrUpdateCustomDomainSettingRequest,  ICustomDomainSettingResult> {
    constructor(params: AddOrUpdateCustomDomainSettingRequest) {
      super('custom_domains_service', 'updateSiteCustomDomainSettings', params);
    }
  }